<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label="label" :placeholder="placeholder" :hint="hint" :hide-details="hideDetails" item-value="id" item-text="name" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter :rules="rules" required>
</v-autocomplete>
</template>

<script>
export default {
    name: `organization-search`,

    props: {
        organization: Object,
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean,
        rules: [Array, Object],
    },

    data() {
        return {
            model: null,
            items: [],
            loading: false,
            search: null
        }
    },

    watch: {

        search(val) {
            if(!val) {
                return
            }
            if(this.model && val === this.model.name) {
                return;
            }
            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

        organization(val) {
            if(!val) {
                return
            }
            this.model = {
                id: val.id,
                name: val.name,
                type: val.type,
            };
            if(val.id && val.name && val.type) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
    },

    methods: {

        getItems(val) {
            // quit early if no search value
            if(!val) {
                return
            }

            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations';

            // prepare params
            let options = {
                params: {
                    search: val,
                    fields: ['name'],
                    size: 5
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        }

    }

}
</script>
